<template>
  <b-button variant="primary" class="searchable-button" :disabled="disabled">
    <input-widget
      type="select2"
      :attribute="attribute"
      :items="items"
      :search-handler="searchHandler"
      :display-field="displayField"
      :value-field="valueField"
      :disabled="disabled"
      :hint="hint"
      :rules="rules"
      :model="model"
      :label="label"
      :options="options"
      @select2Select="onSelect"
    />
  </b-button>
</template>

<script>
  import InputWidget from "../components/input-widget/InputWidget";

  export default {
    name: "SearchableButtonWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      displayField: {
        type: [String, Function],
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: [Boolean, String],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      searchHandler: {
        type: Function,
      }
    },
    data() {
      return {
        items: []
      }
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
        //To prevent selected value being set as button placeholder, items need to be cleaned
        this.items = [];
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "../scss/variables";

  .searchable-button {
    padding: 0;
    border: none !important;

    /deep/ .form-group {
      margin-bottom: 0;

      .select2-selection {
        background-color: $primary;
        text-align: center;
        border: none;
        padding: 6px 12px;

        .select2-selection__placeholder,
        .select2-selection__rendered,
        .select2-selection__clear {
          color: $white;
        }

        .select2-selection__arrow {
          b {
            display: none;
          }
        }
      }
    }
  }
</style>
